export default "__VITE_ASSET__4445baa8__"